import type {FC} from 'react';
import {Box} from '@wellstone-solutions/web';
import {useStores} from 'hooks/useStores';
import {AccessControl} from 'modules/rbac';
import {SessionDocumentList} from '../SessionDocumentList';
import {useDocumentationBreakpoint} from './useDocumentationBreakpoint';
import {getSessionDocumentsTabColumns} from './getSessionDocumentsTabColumns';

const COMPACT_ROW_HEIGHT = 115;

export const SessionDocumentsTab: FC = () => {
  const {meStore, RBACStore} = useStores();
  const breakpoint = useDocumentationBreakpoint();

  const showMyDocuments = RBACStore.hasAccess(
    AccessControl.documentation.viewMySessionDocs,
  );
  const showProgramFilter = RBACStore.hasAccess(
    AccessControl.documentation.viewProgramFilter,
  );

  return (
    <Box mb={1}>
      <SessionDocumentList
        columnNames={getSessionDocumentsTabColumns(breakpoint, {
          showMyDocuments,
        })}
        defaultParams={
          showMyDocuments ? {staff: meStore.activeMembership.id} : {}
        }
        showProgramFilter={showProgramFilter}
        showMemberFilter={true}
        showStaffFilter={!showMyDocuments}
        showDocumentCount={true}
        {...(breakpoint === 'compact' && {
          rowHeight: () => COMPACT_ROW_HEIGHT,
          showGridHeader: false,
        })}
      />
    </Box>
  );
};
